<script lang="ts" setup>
import { computed } from 'vue';

import {
  bgSecondary,
  borderPrimary,
  textSecondary,
} from '@nora-monorepo/ui-shared';

import type { MessageState } from '#nora-chat-ui/states';
import { useReactionsModalStore } from '#nora-chat-ui/stores/conversation/message/reactions-modal-store';

interface MessageReactionsProps {
  messageState: MessageState;
  maxReactions?: number;
}

const props = withDefaults(defineProps<MessageReactionsProps>(), {
  maxReactions: 2,
});

const reactionModalStore = useReactionsModalStore();

const showReactions = computed(
  () =>
    props.messageState.message.reactions?.length
    && !props.messageState.message.deletedAt,
);

const previewReactions = computed(() => {
  if (!props.messageState.message.reactions) {
    return [];
  }
  return props.messageState.message.reactions.slice(0, props.maxReactions);
});

const totalReactions = computed(() => {
  if (!props.messageState.message.reactions) {
    return 0;
  }
  let total = 0;
  props.messageState.message.reactions.forEach((reaction) => {
    total += reaction.count;
  });
  return total;
});

async function openReactionsModal() {
  try {
    await reactionModalStore.openModal(
      props.messageState.message.id,
      props.messageState.message.conversationId,
    );
  }
  catch (error) {
    console.error('Error loading message reactions:', error);
  }
}
</script>

<template>
  <transition name="fade">
    <div v-if="showReactions" class="-ml-2 -mt-2">
      <div
        :class="[borderPrimary, bgSecondary, textSecondary]"
        class="cursor-pointer min-w-full w-auto whitespace-nowrap px-1 rounded-xl text-sm border"
        @click.stop.prevent="openReactionsModal"
      >
        <span
          v-for="reaction in previewReactions"
          :key="reaction.reaction"
          class="pr-1 last:pr-0"
        >
          {{ reaction.reaction }}
        </span>
        <span v-if="messageState.message.reactions">{{ totalReactions }}</span>
      </div>
    </div>
  </transition>
</template>
